import { useEffect } from "react";
import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Stats from "../components/home/stats/Stats";
import TransactionCustomer from "../components/home/TransactionCustomer";
import Table from "../components/Table";
import Layout from "./layout/Layout";
import { parseJWT } from "../../utils/jwtUtils";
import { viewNews } from "../../states/actions/newsAction";
import BaseUrl from "../../service/API/base_url";
import { Avatar } from "@mui/material";

const Dashboard = () => {
  const dispatch = useDispatch();
  const ComponentWrapper = styled(Box)({
    marginTop: "10px",
    paddingBottom: "10px",
  });
  const token = localStorage.getItem("userInfo");
  // Parse the token
  const userRole = parseJWT(token);

  //console.log("user role is : ", userRole);
  const isAdminOrSupperAdmin =
    userRole?.role === "supperAdmin" || userRole?.role === "admin";
  // hooks
  const blogs = useSelector((state) => state.blogs);
  // use effect
  useEffect(() => {
    dispatch(viewNews());
  }, []);
  console.log("news : ", blogs);
  return (
    <Layout title={"Dashboard"}>
      <Box sx={{ pt: "80px", pb: "20px" }}>
        <Typography variant="h6" sx={{ marginBottom: "14px" }}>
          Home
        </Typography>
        <ComponentWrapper>
          <Stats />
        </ComponentWrapper>

        <ComponentWrapper>
          <TransactionCustomer />
        </ComponentWrapper>
        {isAdminOrSupperAdmin && (
          <ComponentWrapper>
            <Typography variant="h5" sx={{ my: 3 }}>
              Aderaw News
            </Typography>
            <Table
              data={blogs?.News}
              fields={newsColumns}
              numberOfRows={5}
              enableTopToolBar={false}
              enableBottomToolBar={false}
              enablePagination={false}
              enableRowSelection={false}
              enableColumnFilters={false}
              enableEditing={false}
              enableColumnDragging={false}
            />
          </ComponentWrapper>
        )}
      </Box>
    </Layout>
  );
};

export default Dashboard;

export const newsColumns = [
  {
    accessorKey: "photo", //access nested data with dot notation
    header: "Images",
    size: 100,
    Cell: ({ cell }) => (
      <div>
        <Avatar
          src={`${BaseUrl}${cell.getValue()}`.replace(/([^:]\/)\/+/g, "$1")}
          // sx={{ width: 100, height: 100 }}
          variant="rounded"
        />
      </div>
    ),
  },
  {
    accessorKey: "author", //access nested data with dot notation
    header: "Author Name",
  },

  {
    accessorKey: "title", //access nested data with dot notation
    header: "Title",
  },

  {
    accessorKey: "description", //access nested data with dot notation
    header: "Description",
  },
];
